module.exports = __webpack_public_path__ + "img/全国直采.d056ea1b.png";